import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  width: "24",
  height: "24",
  viewBox: "0 0 24 24",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [...(_cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      d: "M2 11.4966V10.0352C2 8.2235 3.37169 7.47913 5.0469 8.3877L6.39525 9.12113L7.74359 9.85456C9.4188 10.7631 9.4188 12.2464 7.74359 13.155L6.39525 13.8884L5.0469 14.6218C3.37169 15.514 2 14.7751 2 12.9579V11.4966Z",
      stroke: "currentColor",
      "stroke-width": "1.5",
      "stroke-miterlimit": "10",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, null, -1),
    _createElementVNode("path", {
      d: "M22 11.4966V10.0352C22 8.2235 20.6283 7.47913 18.9531 8.3877L17.6048 9.12113L16.2564 9.85456C14.5812 10.7631 14.5812 12.2464 16.2564 13.155L17.6048 13.8884L18.9531 14.6218C20.6283 15.514 22 14.7751 22 12.9579V11.4966Z",
      stroke: "currentColor",
      "stroke-width": "1.5",
      "stroke-miterlimit": "10",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, null, -1),
    _createElementVNode("path", {
      d: "M12 20V4",
      stroke: "currentColor",
      "stroke-width": "1.5",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, null, -1)
  ]))]))
}
export default { render: render }